import * as React from "react";
const SvgArrowNarrowDownRight = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.269 5.269a1.034 1.034 0 0 1 1.462 0l10.234 10.233V10a1.035 1.035 0 0 1 2.07 0v8c0 .572-.463 1.035-1.035 1.035h-8a1.035 1.035 0 0 1 0-2.07h5.502L5.269 6.73a1.034 1.034 0 0 1 0-1.462"
}));
export default SvgArrowNarrowDownRight;
//# sourceMappingURL=ArrowNarrowDownRight.js.map